import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import type { SupabaseClient } from '../supabase/client';
import type { UpdateStoreDetailsInput, UpdateStoreDetailsResult } from '../types/store';
import { updateStoreDetails } from '../services/update-store-details';

export function useUpdateStoreDetails(
  client: SupabaseClient,
): UseMutationResult<UpdateStoreDetailsResult, unknown, UpdateStoreDetailsInput> {
  const queryClient = useQueryClient();

  return useMutation<UpdateStoreDetailsResult, unknown, UpdateStoreDetailsInput>({
    mutationFn: (input) => updateStoreDetails(client, input),
    onSuccess: (row, variables) => {
      queryClient.setQueryData(['store', variables.storeId], row);
    },
  });
}
